export enum JobSearchType {
  CONTRACTING = "contract",
  FIXED_TERM = "fixed-term",
}
